import { Box, Button, FormControl, Grid, InputLabel, makeStyles, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactExport from "react-export-excel";
import { useSelector } from "react-redux";
import moment from "moment";

const useStyles = makeStyles((theme)=> ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 250
    }
}))

function ResendOrderSearchBar(props){
    const {
        batches, requestNos,
        onBatchSelection, onFetchData, onOpenUploadModal
    } = props;

    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

    const classes = useStyles();
    const {t} = useTranslation('resendOrders'); 

    const orders = useSelector(state => state.resendOrdersReducer.fetchResendOrders);
    const branchList = useSelector(state => state.common.branches);

    const columns = [
        'tno',
        'address1',
        'city',
        'consignee',
        'pathInfo',
        'province',
        'update_time',
        'warehouse',
        'storage_info'
    ]

    const [selectedBatch, setSelectedBatch] = useState("");
    const [selectedRequest, setSelectedRequest]= useState("");
    const [ordersFormattedExcel, setOrdersFormattedExcel] = useState([]);

    useEffect(() => {
        setSelectedBatch("")
        setSelectedRequest("")
    }, [batches])
    useEffect(() => {
        //When request numbers array changed select the first item
        if(requestNos.length > 0){
            setSelectedRequest(requestNos[0].resend_req_no)
        } else {
            setSelectedRequest("")
        }
    }, [requestNos])
    useEffect(() => {
        if(orders) {
            if(orders.length > 0) {
                let ordersFormattedExcelCopy = [];
                orders.map((order) => {
                    let orderFormatted = {};
                    Object.keys(order).map((key) => {
                       columns.map((column) => {
                            if(order[key]) {
                                if(column === 'update_time') {
                                    orderFormatted[key + '_' + column] = timeFormat(order[key][column]);
                                } else if(column === 'warehouse') {
                                    orderFormatted[key + '_' + column] = warehouseFormat(order[key][column]);
                                } else {
                                    orderFormatted[key + '_' + column] = order[key][column];
                                }
                            } else {
                                orderFormatted[key + '_' + column] = '';
                            }
                        }) 
                    })
                    ordersFormattedExcelCopy.push(orderFormatted);
                })
                setOrdersFormattedExcel(ordersFormattedExcelCopy);
            }
        }
    }, [orders])
    useEffect(() => {
        setOrdersFormattedExcel([]);
    }, [])

    function timeFormat(timeStamp) {
        return moment.unix(timeStamp).format("MMM DD, YYYY - HH:mm:ss")
    }
    function warehouseFormat(num) {
        let warehouse = '';
        branchList.map((branch) => {
            if(branch.id === num) {
                warehouse = branch.short_name;
                return;
            }
        })
        return warehouse;
    }

    return (
        <Box>
            <Grid container spacing={2} style={{display: 'flex', alignItems: 'center'}}>
                <Grid item container xs={12} sm={6} md={3} lg={3} xl={2}>
                    <FormControl fullWidth variant="outlined" className={classes.formControl}>
                        <InputLabel id="resend-batch-select-label">{t('resend_batch')}</InputLabel>
                        <Select
                            labelId='resend-batch-select-label'
                            value={selectedBatch}
                            label={t('resend_batch')}
                            onChange={(event)=>_handleBatchSelection(event.target.value)}
                        >
                            {batches.map((batch, index)=>(
                                <MenuItem key={index} value={batch}>{batch}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item container xs={12} sm={6} md={3} lg={3} xl={2}>
                    <FormControl fullWidth variant="outlined" className={classes.formControl}>
                        <InputLabel id="resend-request-select-label">{t('resend_request')}</InputLabel>
                        <Select
                            labelId='resend-request-select-label'
                            value={selectedRequest}
                            label={t('resend_request')}
                            onChange={(event)=>_handleRequestSelection(event.target.value)}
                        >
                            {requestNos.map((request, index)=>(
                                <MenuItem key={index} value={request.resend_req_no}>{request.resend_req_no}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item container xs={12} sm={12} md={2} lg={1} xl={1}>
                    <Button
                        color='secondary'
                        size='small'
                        variant='contained'
                        fullWidth
                        onClick={()=>{onFetchData(selectedBatch, selectedRequest)}}
                    >
                        {t('common:fetch')}
                    </Button>
                </Grid>
                <Grid item container xs={12} sm={12} md={1} lg={1} xl={1} justify="center" alignContent="center">
                    <Typography color='textSecondary'>OR</Typography>
                </Grid>
                <Grid item container xs={12} sm={12} md={2} lg={1} xl={1}>
                    <Button
                        color='secondary'
                        size='small'
                        variant='contained'
                        fullWidth
                        onClick={onOpenUploadModal}
                    >
                        {t('common:upload')}
                    </Button>
                </Grid>
                <Grid item container xs={12} sm={12} md={2} lg={1} xl={1}>
                    {
                        (ordersFormattedExcel && ordersFormattedExcel.length > 0) ?
                        <ExcelFile
                            element={
                                <Button 
                                    color='secondary'
                                    variant='contained'
                                    fullWidth
                                    size='small'
                                    disabled={ordersFormattedExcel.length <= 0}
                                >
                                    {t('download_excel')}
                                </Button>
                            }
                        >
                            <ExcelSheet data={ordersFormattedExcel} name="Resend Orders">
                            {
                                columns.map((column) => (
                                    <ExcelColumn label={'new_order_' + column} value={'new_order_' + column}/>
                                ))
                            }
                            {
                                columns.map((column) => (
                                    <ExcelColumn label={'old_order_' + column} value={'old_order_' + column}/>
                                ))
                            }
                            </ExcelSheet>
                        </ExcelFile>
                        :
                        <Button 
                            color='secondary'
                            variant='contained'
                            fullWidth
                            size='small'
                            disabled
                        >
                            {t('download_excel')}
                        </Button>
                    }
                </Grid>
            </Grid>
        </Box>
    )

    function _handleBatchSelection(value){
        setSelectedBatch(value)
        onBatchSelection(value)
    }

    function _handleRequestSelection(value){
        setSelectedRequest(value)
    }
}

export default ResendOrderSearchBar